import { designTokens } from '@project44/manifest-ds';

export const linkTextWrapper = {
  a: {
    color: designTokens.colorTextTertiary,
  },
  color: designTokens.colorTextTertiary,
};

export const linkWrapper = {
  fontWeight: 'inherit',
  fontSize: 'inherit',
  lineHeight: 'inherit',
};

export const linksWrapper = {
  alignItems: 'baseline',
  width: 'max-content',
  '@media (max-width: 500px)': {
    margin: `0px ${designTokens.spaceXLarge} ${designTokens.spaceXLarge}`,
    flexDirection: 'column-reverse',
    alignItems: 'center',
  },
};

export const linksSection = {
  '@media (min-width: 500px)': {
    marginLeft: designTokens.spaceLarge,
  },
};
